















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_orderMailLogsFragments } from '@/queries/__generated__/orderMailLogsFragments';

@Component
export default class OrderMailLogs extends Vue {
  @Prop({ type: Object, required: true }) private query!: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  @Prop({ type: Object }) private variables!: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  @Prop({ type: Function, required: true }) private queryUpdate!: (data: any) => any; // eslint-disable-line @typescript-eslint/no-explicit-any

  @SmartQuery<OrderMailLogs>({
    query() { return this.query },
    variables() { return (this as any).variables }, // eslint-disable-line @typescript-eslint/no-explicit-any
    update(data) { return this.queryUpdate(data) },
    fetchPolicy: 'no-cache',
  }) private logs!: GQL_orderMailLogsFragments[];
}
